'use strict';
import { fromJS } from 'immutable';
import {
  SALE,
  RENT,
  RENTDAILY,
  APARTMENTS,
  LANDS,
  COMMERCIALS,
  GARAGES,
  APP_NAMES,
  REALTY_TYPES,
  DISTRICTS
} from '../consts';
import { DEFAULT_STATE_FILTER as DEFAULT_STATE_FILTER_SEARCH } from '../app/Search/reducer';

export const RESIDENTIAL_COMPLEX = '/zhilye-kompleksy/';
export const COTTAGE_VILLAGE = '/kottedzhnyye-poselki/';

export const SALE_APARTMENTS_HOME = '/';
export const SALE_APARTMENTS_1_ROOM = '/prodazha-1-komnatnye-kvartiry/';
export const SALE_APARTMENTS_2_ROOM = '/prodazha-2-komnatnye-kvartiry/';
export const SALE_APARTMENTS_3_ROOM = '/prodazha-3-komnatnye-kvartiry/';
export const SALE_APARTMENTS_4_ROOM = '/prodazha-4-komnatnye-kvartiry/';
export const SALE_APARTMENTS_5_ROOM = '/prodazha-5-komnatnye-kvartiry/';
export const SALE_APARTMENTS_ROOMS = '/prodazha-komnaty/';
export const SALE_APARTMENTS_PART = '/prodazha-dolia-v-kvartire/';
// новостройки
export const SALE_APARTMENTS_NEWBUILDING = '/pokupka-kvartiry-v-novostrojke/';
export const SALE_APARTMENTS_1_ROOM_NEW = '/prodazha-1-komnatnye-kvartiry-v-novostrojke/';
export const SALE_APARTMENTS_2_ROOM_NEW = '/prodazha-2-komnatnye-kvartiry-v-novostrojke/';
export const SALE_APARTMENTS_3_ROOM_NEW = '/prodazha-3-komnatnye-kvartiry-v-novostrojke/';
export const SALE_APARTMENTS_4_ROOM_NEW = '/prodazha-4-komnatnye-kvartiry-v-novostrojke/';
export const SALE_APARTMENTS_5_ROOM_NEW = '/prodazha-5-komnatnye-kvartiry-v-novostrojke/';
export const SALE_APARTMENTS_ROOMS_NEW = '/prodazha-komnaty-v-novostrojke/';
export const SALE_APARTMENTS_PART_NEW = '/prodazha-dolia-v-kvartire-v-novostrojke/';
// районы
export const SALE_APARTMENTS_KIROVSKIJ = '/pokupka-nedvizhimost-kirovskij/';
export const SALE_APARTMENTS_LENINSKIJ = '/pokupka-nedvizhimost-leninskij/';
export const SALE_APARTMENTS_OKTYABRSKIJ = '/pokupka-nedvizhimost-oktyabrskij/';
export const SALE_APARTMENTS_SOVETSKIJ = '/pokupka-nedvizhimost-sovetskij/';
export const SALE_APARTMENTS_CENTRALNYJ = '/pokupka-nedvizhimost-centralnyj/';
export const SALE_APARTMENTS_CENTR = '/pokupka-nedvizhimost-centr/';
export const SALE_APARTMENTS_OBLAST = '/pokupka-nedvizhimost-oblast/';

export const RENT_APARTMENTS_HOME = '/arenda-kvartiry/';
export const RENT_APARTMENTS_1_ROOM = '/arenda-1-komnatnye-kvartiry/';
export const RENT_APARTMENTS_2_ROOM = '/arenda-2-komnatnye-kvartiry/';
export const RENT_APARTMENTS_3_ROOM = '/arenda-3-komnatnye-kvartiry/';
export const RENT_APARTMENTS_4_ROOM = '/arenda-4-komnatnye-kvartiry/';
export const RENT_APARTMENTS_5_ROOM = '/arenda-5-komnatnye-kvartiry/';
export const RENT_APARTMENTS_ROOMS = '/arenda-komnaty/';
export const RENT_APARTMENTS_HOUSE = '/arenda-doma/';
export const RENT_APARTMENTS_HOUSE_COTTAGE = '/arenda-doma-kottedzhi/';
export const RENT_APARTMENTS_COTTAGE = '/arenda-kottedzhi/';
export const RENT_APARTMENTS_TOWNHOUSE = '/arenda-townhouse/';
// районы
export const RENT_APARTMENTS_KIROVSKIJ = '/arenda-nedvizhimost-kirovskij/';
export const RENT_APARTMENTS_LENINSKIJ = '/arenda-nedvizhimost-leninskij/';
export const RENT_APARTMENTS_OKTYABRSKIJ = '/arenda-nedvizhimost-oktyabrskij/';
export const RENT_APARTMENTS_SOVETSKIJ = '/arenda-nedvizhimost-sovetskij/';
export const RENT_APARTMENTS_CENTRALNYJ = '/arenda-nedvizhimost-centralnyj/';
export const RENT_APARTMENTS_CENTR = '/arenda-nedvizhimost-centr/';
export const RENT_APARTMENTS_OBLAST = '/arenda-nedvizhimost-oblast/';

export const RENTDAILY_HOME = '/posutochnaja-arenda-kvartiry/';
export const RENTDAILY_1_ROOM = '/posutochnaja-arenda-1-komnatnye-kvartiry/';
export const RENTDAILY_2_ROOM = '/posutochnaja-arenda-2-komnatnye-kvartiry/';
export const RENTDAILY_3_ROOM = '/posutochnaja-arenda-3-komnatnye-kvartiry/';
export const RENTDAILY_4_ROOM = '/posutochnaja-arenda-4-komnatnye-kvartiry/';
export const RENTDAILY_HOUSE = '/posutochnaja-arenda-doma/';
export const RENTDAILY_COTTAGE = '/posutochnaja-arenda-kottedzhi/';
export const RENTDAILY_TOWNHOUSE = '/posutochnaja-arenda-townhouse/';
export const RENTDAILY_HOSTEL = '/posutochnaja-arenda-hostel/';
// районы
export const RENTDAILY_KIROVSKIJ = '/posutochnaja-arenda-nedvizhimost-kirovskij/';
export const RENTDAILY_LENINSKIJ = '/posutochnaja-arenda-nedvizhimost-leninskij/';
export const RENTDAILY_OKTYABRSKIJ = '/posutochnaja-arenda-nedvizhimost-oktyabrskij/';
export const RENTDAILY_SOVETSKIJ = '/posutochnaja-arenda-nedvizhimost-sovetskij/';
export const RENTDAILY_CENTRALNYJ = '/posutochnaja-arenda-nedvizhimost-centralnyj/';
export const RENTDAILY_CENTR = '/posutochnaja-arenda-nedvizhimost-centr/';
export const RENTDAILY_OBLAST = '/posutochnaja-arenda-nedvizhimost-oblast/';

export const SALE_LAND_HOME = '/dachi-i-uchastki/';
export const SALE_LAND_HOUSE = '/prodazha-doma/';
export const SALE_LAND_COTTAGE = '/prodazha-kottedzhi/';
export const SALE_LAND_TOWNHOUSE = '/prodazha-taunxausy/';
export const SALE_LAND_DACHA = '/prodazha-dachi/';
export const SALE_LAND_LANDS = '/prodazha-zemelnye-uchastki/';
// районы
export const SALE_LAND_KIROVSKIJ = '/pokupka-dachi-i-uchastki-kirovskij/';
export const SALE_LAND_LENINSKIJ = '/pokupka-dachi-i-uchastki-leninskij/';
export const SALE_LAND_OKTYABRSKIJ = '/pokupka-dachi-i-uchastki-oktyabrskij/';
export const SALE_LAND_SOVETSKIJ = '/pokupka-dachi-i-uchastki-sovetskij/';
export const SALE_LAND_CENTRALNYJ = '/pokupka-dachi-i-uchastki-centralnyj/';
export const SALE_LAND_CENTR = '/pokupka-dachi-i-uchastki-centr/';
export const SALE_LAND_OBLAST = '/pokupka-dachi-i-uchastki-oblast/';

export const GARAGES_HOME = '/garazhi/';
export const GARAGES_CAPITAL = '/garazh-kapitalnyj/';
export const GARAGES_CONCRETE = '/garazh-zhelezobetonnyj/';
export const GARAGES_METAL = '/garazh-metallicheskij/';
export const GARAGES_PLACE = '/garazh-mashinomesto/';
export const GARAGES_TODAY = '/garazh-za-segodnya/';
export const GARAGES_WEEK = '/garazh-za-nedelyu/';
// районы
export const GARAGES_KIROVSKIJ = '/pokupka-garazhi-kirovskij/';
export const GARAGES_LENINSKIJ = '/pokupka-garazhi-leninskij/';
export const GARAGES_OKTYABRSKIJ = '/pokupka-garazhi-oktyabrskij/';
export const GARAGES_SOVETSKIJ = '/pokupka-garazhi-sovetskij/';
export const GARAGES_CENTRALNYJ = '/pokupka-garazhi-centralnyj/';
export const GARAGES_CENTR = '/pokupka-garazhi-centr/';
export const GARAGES_OBLAST = '/pokupka-garazhi-oblast/';

export const SALE_COMMERCIALS_HOME = '/kommercheskaja-nedvizhimost/';
export const SALE_COMMERCIALS_OFFICE = '/prodazha-ofisnye-pomeshheniya/';
export const SALE_COMMERCIALS_SHELF_SPACE = '/prodazha-torgovye-ploshhadi-magaziny/';
export const SALE_COMMERCIALS_WAREHOUSE = '/prodazha-sklady-proizvodstvo/';
export const SALE_COMMERCIALS_CATERING = '/prodazha-obshhepit-dosug/';
export const SALE_COMMERCIALS_SERVICE_STATION = '/prodazha-sto/';
export const SALE_COMMERCIALS_BUSINESS = '/prodazha-gotovyj-biznes/';
export const SALE_COMMERCIALS_FREE = '/prodazha-ploshhadi-svobodnogo-naznacheniya/';
export const SALE_COMMERCIALS_ONE_FLOOR = '/prodazha-kvartiry-na-pervom-etage/';
export const SALE_COMMERCIALS_OWNER = '/prodazha-chastnye-obyavleniya/';
// районы
export const SALE_COMMERCIALS_KIROVSKIJ = '/pokupka-kommercheskaja-nedvizhimost-kirovskij/';
export const SALE_COMMERCIALS_LENINSKIJ = '/pokupka-kommercheskaja-nedvizhimost-leninskij/';
export const SALE_COMMERCIALS_OKTYABRSKIJ = '/pokupka-kommercheskaja-nedvizhimost-oktyabrskij/';
export const SALE_COMMERCIALS_SOVETSKIJ = '/pokupka-kommercheskaja-nedvizhimost-sovetskij/';
export const SALE_COMMERCIALS_CENTRALNYJ = '/pokupka-kommercheskaja-nedvizhimost-centralnyj/';
export const SALE_COMMERCIALS_CENTR = '/pokupka-kommercheskaja-nedvizhimost-centr/';
export const SALE_COMMERCIALS_OBLAST = '/pokupka-kommercheskaja-nedvizhimost-oblast/';

export const RENT_COMMERCIALS_HOME = '/rent-kommercheskaja-nedvizhimost/';
export const RENT_COMMERCIALS_OFFICE = '/arenda-ofisnye-pomeshheniya/';
export const RENT_COMMERCIALS_SHELF_SPACE = '/arenda-torgovye-ploshhadi-magaziny/';
export const RENT_COMMERCIALS_WAREHOUSE = '/arenda-sklady-proizvodstvo/';
export const RENT_COMMERCIALS_CATERING = '/arenda-obshhepit-dosug/';
export const RENT_COMMERCIALS_SERVICE_STATION = '/arenda-sto/';
export const RENT_COMMERCIALS_BUSINESS = '/arenda-gotovyj-biznes/';
export const RENT_COMMERCIALS_FREE = '/arenda-ploshhadi-svobodnogo-naznacheniya/';
export const RENT_COMMERCIALS_ONE_FLOOR = '/arenda-kvartiry-na-pervom-etage/';
export const RENT_COMMERCIALS_OWNER = '/arenda-chastnye-obyavleniya/';
// районы
export const RENT_COMMERCIALS_KIROVSKIJ = '/arenda-kommercheskaja-nedvizhimost-kirovskij/';
export const RENT_COMMERCIALS_LENINSKIJ = '/arenda-kommercheskaja-nedvizhimost-leninskij/';
export const RENT_COMMERCIALS_OKTYABRSKIJ = '/arenda-kommercheskaja-nedvizhimost-oktyabrskij/';
export const RENT_COMMERCIALS_SOVETSKIJ = '/arenda-kommercheskaja-nedvizhimost-sovetskij/';
export const RENT_COMMERCIALS_CENTRALNYJ = '/arenda-kommercheskaja-nedvizhimost-centralnyj/';
export const RENT_COMMERCIALS_CENTR = '/arenda-kommercheskaja-nedvizhimost-centr/';
export const RENT_COMMERCIALS_OBLAST = '/arenda-kommercheskaja-nedvizhimost-oblast/';

export const aliases = fromJS({
// продажа жилой
  [SALE_APARTMENTS_NEWBUILDING]: {
    query: {
      isNewBuilding: '1'
    },
    dealType: SALE,
    realtyType: APARTMENTS
  },
  [SALE_APARTMENTS_1_ROOM]: {
    query: {
      objectTypeId: `${REALTY_TYPES.flat1}`
    },
    dealType: SALE,
    realtyType: APARTMENTS
  },
  [SALE_APARTMENTS_2_ROOM]: {
    query: {
      objectTypeId: `${REALTY_TYPES.flat2}`
    },
    dealType: SALE,
    realtyType: APARTMENTS
  },
  [SALE_APARTMENTS_3_ROOM]: {
    query: {
      objectTypeId: `${REALTY_TYPES.flat3}`
    },
    dealType: SALE,
    realtyType: APARTMENTS
  },
  [SALE_APARTMENTS_4_ROOM]: {
    query: {
      objectTypeId: `${REALTY_TYPES.flat4}`
    },
    dealType: SALE,
    realtyType: APARTMENTS
  },
  [SALE_APARTMENTS_5_ROOM]: {
    query: {
      objectTypeId: `${REALTY_TYPES.flat5}`
    },
    dealType: SALE,
    realtyType: APARTMENTS
  },
  [SALE_APARTMENTS_ROOMS]: {
    query: {
      objectTypeId: `${REALTY_TYPES.room}`
    },
    dealType: SALE,
    realtyType: APARTMENTS
  },
  [SALE_APARTMENTS_PART]: {
    query: {
      objectTypeId: `${REALTY_TYPES.flatParts}`
    },
    dealType: SALE,
    realtyType: APARTMENTS
  },
  // новостройки
  [SALE_APARTMENTS_1_ROOM_NEW]: {
    query: {
      isNewBuilding: '1',
      objectTypeId: `${REALTY_TYPES.flat1}`
    },
    dealType: SALE,
    realtyType: APARTMENTS
  },
  [SALE_APARTMENTS_2_ROOM_NEW]: {
    query: {
      isNewBuilding: '1',
      objectTypeId: `${REALTY_TYPES.flat2}`
    },
    dealType: SALE,
    realtyType: APARTMENTS
  },
  [SALE_APARTMENTS_3_ROOM_NEW]: {
    query: {
      isNewBuilding: '1',
      objectTypeId: `${REALTY_TYPES.flat3}`
    },
    dealType: SALE,
    realtyType: APARTMENTS
  },
  [SALE_APARTMENTS_4_ROOM_NEW]: {
    query: {
      isNewBuilding: '1',
      objectTypeId: `${REALTY_TYPES.flat4}`
    },
    dealType: SALE,
    realtyType: APARTMENTS
  },
  [SALE_APARTMENTS_5_ROOM_NEW]: {
    query: {
      isNewBuilding: '1',
      objectTypeId: `${REALTY_TYPES.flat5}`
    },
    dealType: SALE,
    realtyType: APARTMENTS
  },
  [SALE_APARTMENTS_ROOMS_NEW]: {
    query: {
      isNewBuilding: '1',
      objectTypeId: `${REALTY_TYPES.room}`
    },
    dealType: SALE,
    realtyType: APARTMENTS
  },
  [SALE_APARTMENTS_PART_NEW]: {
    query: {
      isNewBuilding: '1',
      objectTypeId: `${REALTY_TYPES.flatParts}`
    },
    dealType: SALE,
    realtyType: APARTMENTS
  },
  // районы
  [SALE_APARTMENTS_KIROVSKIJ]: {
    query: {
      district: `${DISTRICTS.kirovskij}`
    },
    dealType: SALE,
    realtyType: APARTMENTS
  },
  [SALE_APARTMENTS_LENINSKIJ]: {
    query: {
      district: `${DISTRICTS.leninskij}`
    },
    dealType: SALE,
    realtyType: APARTMENTS
  },
  [SALE_APARTMENTS_OKTYABRSKIJ]: {
    query: {
      district: `${DISTRICTS.oktyabrskij}`
    },
    dealType: SALE,
    realtyType: APARTMENTS
  },
  [SALE_APARTMENTS_SOVETSKIJ]: {
    query: {
      district: `${DISTRICTS.sovetskij}`
    },
    dealType: SALE,
    realtyType: APARTMENTS
  },
  [SALE_APARTMENTS_CENTRALNYJ]: {
    query: {
      district: `${DISTRICTS.centralnyj}`
    },
    dealType: SALE,
    realtyType: APARTMENTS
  },
  [SALE_APARTMENTS_CENTR]: {
    query: {
      district: `${DISTRICTS.center}`
    },
    dealType: SALE,
    realtyType: APARTMENTS
  },
  [SALE_APARTMENTS_OBLAST]: {
    query: {
      district: `${DISTRICTS.suburb}`
    },
    dealType: SALE,
    realtyType: APARTMENTS
  },

// аренда жилой длительная
  [RENT_APARTMENTS_1_ROOM]: {
    query: {
      objectTypeId: `${REALTY_TYPES.flat1}`
    },
    dealType: RENT,
    realtyType: APARTMENTS
  },
  [RENT_APARTMENTS_2_ROOM]: {
    query: {
      objectTypeId: `${REALTY_TYPES.flat2}`
    },
    dealType: RENT,
    realtyType: APARTMENTS
  },
  [RENT_APARTMENTS_3_ROOM]: {
    query: {
      objectTypeId: `${REALTY_TYPES.flat3}`
    },
    dealType: RENT,
    realtyType: APARTMENTS
  },
  [RENT_APARTMENTS_4_ROOM]: {
    query: {
      objectTypeId: `${REALTY_TYPES.flat4}`
    },
    dealType: RENT,
    realtyType: APARTMENTS
  },
  [RENT_APARTMENTS_5_ROOM]: {
    query: {
      objectTypeId: `${REALTY_TYPES.flat5}`
    },
    dealType: RENT,
    realtyType: APARTMENTS
  },
  [RENT_APARTMENTS_ROOMS]: {
    query: {
      objectTypeId: `${REALTY_TYPES.room}`
    },
    dealType: RENT,
    realtyType: APARTMENTS
  },
  [RENT_APARTMENTS_HOUSE]: {
    query: {
      objectTypeId: `${REALTY_TYPES.house}`
    },
    dealType: RENT,
    realtyType: APARTMENTS
  },
  [RENT_APARTMENTS_COTTAGE]: {
    query: {
      objectTypeId: `${REALTY_TYPES.cottage}`
    },
    dealType: RENT,
    realtyType: APARTMENTS
  },
  [RENT_APARTMENTS_TOWNHOUSE]: {
    query: {
      objectTypeId: `${REALTY_TYPES.townHouse}`
    },
    dealType: RENT,
    realtyType: APARTMENTS
  },
  [RENT_APARTMENTS_HOUSE_COTTAGE]: {
    query: {
      objectTypeId: `${REALTY_TYPES.house},${REALTY_TYPES.cottage}`
    },
    dealType: RENT,
    realtyType: APARTMENTS
  },
  // районы
  [RENT_APARTMENTS_KIROVSKIJ]: {
    query: {
      district: `${DISTRICTS.kirovskij}`
    },
    dealType: RENT,
    realtyType: APARTMENTS
  },
  [RENT_APARTMENTS_LENINSKIJ]: {
    query: {
      district: `${DISTRICTS.leninskij}`
    },
    dealType: RENT,
    realtyType: APARTMENTS
  },
  [RENT_APARTMENTS_OKTYABRSKIJ]: {
    query: {
      district: `${DISTRICTS.oktyabrskij}`
    },
    dealType: RENT,
    realtyType: APARTMENTS
  },
  [RENT_APARTMENTS_SOVETSKIJ]: {
    query: {
      district: `${DISTRICTS.sovetskij}`
    },
    dealType: RENT,
    realtyType: APARTMENTS
  },
  [RENT_APARTMENTS_CENTRALNYJ]: {
    query: {
      district: `${DISTRICTS.centralnyj}`
    },
    dealType: RENT,
    realtyType: APARTMENTS
  },
  [RENT_APARTMENTS_CENTR]: {
    query: {
      district: `${DISTRICTS.center}`
    },
    dealType: RENT,
    realtyType: APARTMENTS
  },
  [RENT_APARTMENTS_OBLAST]: {
    query: {
      district: `${DISTRICTS.suburb}`
    },
    dealType: RENT,
    realtyType: APARTMENTS
  },

// аренда жилой посуточная
  [RENTDAILY_1_ROOM]: {
    query: {
      objectTypeId: `${REALTY_TYPES.flat1}`
    },
    dealType: RENTDAILY,
    realtyType: APARTMENTS
  },
  [RENTDAILY_2_ROOM]: {
    query: {
      objectTypeId: `${REALTY_TYPES.flat2}`
    },
    dealType: RENTDAILY,
    realtyType: APARTMENTS
  },
  [RENTDAILY_3_ROOM]: {
    query: {
      objectTypeId: `${REALTY_TYPES.flat3}`
    },
    dealType: RENTDAILY,
    realtyType: APARTMENTS
  },
  [RENTDAILY_4_ROOM]: {
    query: {
      objectTypeId: `${REALTY_TYPES.flat4}`
    },
    dealType: RENTDAILY,
    realtyType: APARTMENTS
  },
  [RENTDAILY_HOUSE]: {
    query: {
      objectTypeId: `${REALTY_TYPES.house}`
    },
    dealType: RENTDAILY,
    realtyType: APARTMENTS
  },
  [RENTDAILY_COTTAGE]: {
    query: {
      objectTypeId: `${REALTY_TYPES.cottage}`
    },
    dealType: RENTDAILY,
    realtyType: APARTMENTS
  },
  [RENTDAILY_TOWNHOUSE]: {
    query: {
      objectTypeId: `${REALTY_TYPES.townHouse}`
    },
    dealType: RENTDAILY,
    realtyType: APARTMENTS
  },
  [RENTDAILY_HOSTEL]: {
    query: {
      objectTypeId: `${REALTY_TYPES.hostel}`
    },
    dealType: RENTDAILY,
    realtyType: APARTMENTS
  },
  // районы
  [RENTDAILY_KIROVSKIJ]: {
    query: {
      district: `${DISTRICTS.kirovskij}`
    },
    dealType: RENTDAILY,
    realtyType: APARTMENTS
  },
  [RENTDAILY_LENINSKIJ]: {
    query: {
      district: `${DISTRICTS.leninskij}`
    },
    dealType: RENTDAILY,
    realtyType: APARTMENTS
  },
  [RENTDAILY_OKTYABRSKIJ]: {
    query: {
      district: `${DISTRICTS.oktyabrskij}`
    },
    dealType: RENTDAILY,
    realtyType: APARTMENTS
  },
  [RENTDAILY_SOVETSKIJ]: {
    query: {
      district: `${DISTRICTS.sovetskij}`
    },
    dealType: RENTDAILY,
    realtyType: APARTMENTS
  },
  [RENTDAILY_CENTRALNYJ]: {
    query: {
      district: `${DISTRICTS.centralnyj}`
    },
    dealType: RENTDAILY,
    realtyType: APARTMENTS
  },
  [RENTDAILY_CENTR]: {
    query: {
      district: `${DISTRICTS.center}`
    },
    dealType: RENTDAILY,
    realtyType: APARTMENTS
  },
  [RENTDAILY_OBLAST]: {
    query: {
      district: `${DISTRICTS.suburb}`
    },
    dealType: RENTDAILY,
    realtyType: APARTMENTS
  },

  // Дома / участки
  [SALE_LAND_HOUSE]: {
    query: {
      objectTypeId: `${REALTY_TYPES.house}`
    },
    dealType: SALE,
    realtyType: LANDS
  },
  [SALE_LAND_COTTAGE]: {
    query: {
      objectTypeId: `${REALTY_TYPES.cottage}`
    },
    dealType: SALE,
    realtyType: LANDS
  },
  [SALE_LAND_TOWNHOUSE]: {
    query: {
      objectTypeId: `${REALTY_TYPES.townHouse}`
    },
    dealType: SALE,
    realtyType: LANDS
  },
  [SALE_LAND_DACHA]: {
    query: {
      objectTypeId: `${REALTY_TYPES.dacha}`
    },
    dealType: SALE,
    realtyType: LANDS
  },
  [SALE_LAND_LANDS]: {
    query: {
      objectTypeId: `${REALTY_TYPES.land}`
    },
    dealType: SALE,
    realtyType: LANDS
  },
  // районы
  [SALE_LAND_KIROVSKIJ]: {
    query: {
      district: `${DISTRICTS.kirovskij}`
    },
    dealType: SALE,
    realtyType: LANDS
  },
  [SALE_LAND_LENINSKIJ]: {
    query: {
      district: `${DISTRICTS.leninskij}`
    },
    dealType: SALE,
    realtyType: LANDS
  },
  [SALE_LAND_OKTYABRSKIJ]: {
    query: {
      district: `${DISTRICTS.oktyabrskij}`
    },
    dealType: SALE,
    realtyType: LANDS
  },
  [SALE_LAND_SOVETSKIJ]: {
    query: {
      district: `${DISTRICTS.sovetskij}`
    },
    dealType: SALE,
    realtyType: LANDS
  },
  [SALE_LAND_CENTRALNYJ]: {
    query: {
      district: `${DISTRICTS.centralnyj}`
    },
    dealType: SALE,
    realtyType: LANDS
  },
  [SALE_LAND_CENTR]: {
    query: {
      district: `${DISTRICTS.center}`
    },
    dealType: SALE,
    realtyType: LANDS
  },
  [SALE_LAND_OBLAST]: {
    query: {
      district: `${DISTRICTS.suburb}`
    },
    dealType: SALE,
    realtyType: LANDS
  },

  // гаражи
  [GARAGES_CAPITAL]: {
    query: {
      objectTypeId: '264'
    },
    dealType: SALE,
    realtyType: GARAGES
  },
  [GARAGES_CONCRETE]: {
    query: {
      objectTypeId: '312'
    },
    dealType: SALE,
    realtyType: GARAGES
  },
  [GARAGES_METAL]: {
    query: {
      objectTypeId: '311'
    },
    dealType: SALE,
    realtyType: GARAGES
  },
  [GARAGES_PLACE]: {
    query: {
      objectTypeId: '306'
    },
    dealType: SALE,
    realtyType: GARAGES
  },
  [GARAGES_TODAY]: {
    query: {
      interval: '24'
    },
    dealType: SALE,
    realtyType: GARAGES
  },
  [GARAGES_WEEK]: {
    query: {
      interval: '7'
    },
    dealType: SALE,
    realtyType: GARAGES
  },
  // районы
  [GARAGES_KIROVSKIJ]: {
    query: {
      district: `${DISTRICTS.kirovskij}`
    },
    dealType: SALE,
    realtyType: GARAGES
  },
  [GARAGES_LENINSKIJ]: {
    query: {
      district: `${DISTRICTS.leninskij}`
    },
    dealType: SALE,
    realtyType: GARAGES
  },
  [GARAGES_OKTYABRSKIJ]: {
    query: {
      district: `${DISTRICTS.oktyabrskij}`
    },
    dealType: SALE,
    realtyType: GARAGES
  },
  [GARAGES_SOVETSKIJ]: {
    query: {
      district: `${DISTRICTS.sovetskij}`
    },
    dealType: SALE,
    realtyType: GARAGES
  },
  [GARAGES_CENTRALNYJ]: {
    query: {
      district: `${DISTRICTS.centralnyj}`
    },
    dealType: SALE,
    realtyType: GARAGES
  },
  [GARAGES_CENTR]: {
    query: {
      district: `${DISTRICTS.center}`
    },
    dealType: SALE,
    realtyType: GARAGES
  },
  [GARAGES_OBLAST]: {
    query: {
      district: `${DISTRICTS.suburb}`
    },
    dealType: SALE,
    realtyType: GARAGES
  },

  // коммерческая продажа
  [SALE_COMMERCIALS_OFFICE]: {
    query: {
      objectTypeId: '37'
    },
    dealType: SALE,
    realtyType: COMMERCIALS
  },
  [SALE_COMMERCIALS_SHELF_SPACE]: {
    query: {
      objectTypeId: '38'
    },
    dealType: SALE,
    realtyType: COMMERCIALS
  },
  [SALE_COMMERCIALS_WAREHOUSE]: {
    query: {
      objectTypeId: '39'
    },
    dealType: SALE,
    realtyType: COMMERCIALS
  },
  [SALE_COMMERCIALS_CATERING]: {
    query: {
      objectTypeId: '40'
    },
    dealType: SALE,
    realtyType: COMMERCIALS
  },
  [SALE_COMMERCIALS_SERVICE_STATION]: {
    query: {
      objectTypeId: '41'
    },
    dealType: SALE,
    realtyType: COMMERCIALS
  },
  [SALE_COMMERCIALS_BUSINESS]: {
    query: {
      objectTypeId: '42'
    },
    dealType: SALE,
    realtyType: COMMERCIALS
  },
  [SALE_COMMERCIALS_FREE]: {
    query: {
      objectTypeId: '43'
    },
    dealType: SALE,
    realtyType: COMMERCIALS
  },
  [SALE_COMMERCIALS_ONE_FLOOR]: {
    query: {
      objectTypeId: `${REALTY_TYPES.flatOneFloor}`
    },
    dealType: SALE,
    realtyType: COMMERCIALS
  },
  [SALE_COMMERCIALS_OWNER]: {
    query: {
      onlyOwners: '1'
    },
    dealType: SALE,
    realtyType: COMMERCIALS
  },
  // районы
  [SALE_COMMERCIALS_KIROVSKIJ]: {
    query: {
      district: `${DISTRICTS.kirovskij}`
    },
    dealType: SALE,
    realtyType: COMMERCIALS
  },
  [SALE_COMMERCIALS_LENINSKIJ]: {
    query: {
      district: `${DISTRICTS.leninskij}`
    },
    dealType: SALE,
    realtyType: COMMERCIALS
  },
  [SALE_COMMERCIALS_OKTYABRSKIJ]: {
    query: {
      district: `${DISTRICTS.oktyabrskij}`
    },
    dealType: SALE,
    realtyType: COMMERCIALS
  },
  [SALE_COMMERCIALS_SOVETSKIJ]: {
    query: {
      district: `${DISTRICTS.sovetskij}`
    },
    dealType: SALE,
    realtyType: COMMERCIALS
  },
  [SALE_COMMERCIALS_CENTRALNYJ]: {
    query: {
      district: `${DISTRICTS.centralnyj}`
    },
    dealType: SALE,
    realtyType: COMMERCIALS
  },
  [SALE_COMMERCIALS_CENTR]: {
    query: {
      district: `${DISTRICTS.center}`
    },
    dealType: SALE,
    realtyType: COMMERCIALS
  },
  [SALE_COMMERCIALS_OBLAST]: {
    query: {
      district: `${DISTRICTS.suburb}`
    },
    dealType: SALE,
    realtyType: COMMERCIALS
  },

  // коммерческая аренда
  [RENT_COMMERCIALS_OFFICE]: {
    query: {
      objectTypeId: '37'
    },
    dealType: RENT,
    realtyType: COMMERCIALS
  },
  [RENT_COMMERCIALS_SHELF_SPACE]: {
    query: {
      objectTypeId: '38'
    },
    dealType: RENT,
    realtyType: COMMERCIALS
  },
  [RENT_COMMERCIALS_WAREHOUSE]: {
    query: {
      objectTypeId: '39'
    },
    dealType: RENT,
    realtyType: COMMERCIALS
  },
  [RENT_COMMERCIALS_CATERING]: {
    query: {
      objectTypeId: '40'
    },
    dealType: RENT,
    realtyType: COMMERCIALS
  },
  [RENT_COMMERCIALS_SERVICE_STATION]: {
    query: {
      objectTypeId: '41'
    },
    dealType: RENT,
    realtyType: COMMERCIALS
  },
  [RENT_COMMERCIALS_BUSINESS]: {
    query: {
      objectTypeId: '42'
    },
    dealType: RENT,
    realtyType: COMMERCIALS
  },
  [RENT_COMMERCIALS_FREE]: {
    query: {
      objectTypeId: '43'
    },
    dealType: RENT,
    realtyType: COMMERCIALS
  },
  [RENT_COMMERCIALS_ONE_FLOOR]: {
    query: {
      objectTypeId: `${REALTY_TYPES.flatOneFloor}`
    },
    dealType: RENT,
    realtyType: COMMERCIALS
  },
  [RENT_COMMERCIALS_OWNER]: {
    query: {
      onlyOwners: '1'
    },
    dealType: RENT,
    realtyType: COMMERCIALS
  },
  // районы
  [RENT_COMMERCIALS_KIROVSKIJ]: {
    query: {
      district: `${DISTRICTS.kirovskij}`
    },
    dealType: RENT,
    realtyType: COMMERCIALS
  },
  [RENT_COMMERCIALS_LENINSKIJ]: {
    query: {
      district: `${DISTRICTS.leninskij}`
    },
    dealType: RENT,
    realtyType: COMMERCIALS
  },
  [RENT_COMMERCIALS_OKTYABRSKIJ]: {
    query: {
      district: `${DISTRICTS.oktyabrskij}`
    },
    dealType: RENT,
    realtyType: COMMERCIALS
  },
  [RENT_COMMERCIALS_SOVETSKIJ]: {
    query: {
      district: `${DISTRICTS.sovetskij}`
    },
    dealType: RENT,
    realtyType: COMMERCIALS
  },
  [RENT_COMMERCIALS_CENTRALNYJ]: {
    query: {
      district: `${DISTRICTS.centralnyj}`
    },
    dealType: RENT,
    realtyType: COMMERCIALS
  },
  [RENT_COMMERCIALS_CENTR]: {
    query: {
      district: `${DISTRICTS.center}`
    },
    dealType: RENT,
    realtyType: COMMERCIALS
  },
  [RENT_COMMERCIALS_OBLAST]: {
    query: {
      district: `${DISTRICTS.suburb}`
    },
    dealType: RENT,
    realtyType: COMMERCIALS
  }
});

export default function getAlias (aliasKey) {
  return aliases.get(aliasKey);
}

export function findByQuery (dealType, realtyType, query) {
  const alias = aliases.filter((alias, k) => {
    const aliasQuery = alias.get('query');

    return alias.get('dealType') === dealType &&
          alias.get('realtyType') === realtyType &&
          query.filter((val, key) => aliasQuery.get(key) != val).size === 0 &&
          aliasQuery.filter((val, key) => query.get(key) != val).size === 0;
  });

  return alias.count() === 1 ? alias.keySeq().first() : false;
}

export function parseAliasQuery (pathname, filterType) {
  let alias = getAlias(pathname);
  let filter = new Map();

  switch (filterType) {
    case APP_NAMES.search: filter = fromJS(DEFAULT_STATE_FILTER_SEARCH);
  }

  return alias ? filter.merge(alias.get('query')) : filter;
}



// WEBPACK FOOTER //
// ./src/utils/aliases.js